import styled from '@emotion/styled';
import { Accordion, AccordionSummary, Box, Tabs as MuiTabs, Typography } from '@mui/material';
import { Dialog } from '../../../shared/dialog/dialog.styles';

export const DialogContent = styled(Box)({
  border: '1px solid #D9D9D9',
  maxHeight: '505px',
  borderRadius: '4px',
  overflowY: 'auto',
  marginTop: '24px',
  padding: '24px'
});

export const MessageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '20px',
  clear: 'both'
});

export const SenderLabel = styled('div')({
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '22px',
  color: '#0D082C',
  width: '46px',
  height: '22px',
  marginBottom: '5px'
});

export const MessageContent = styled('div')<{ isAgent: boolean }>(({ isAgent }) => ({
  padding: '10px 15px',
  marginBottom: '27px',
  maxWidth: '418px',
  wordWrap: 'break-word',
  fontSize: '16px',
  position: 'relative',
  ...(isAgent
    ? {
        alignSelf: 'flex-start',
        backgroundColor: '#EBEBEB',
        color: '#000',
        borderRadius: '0px 10px 10px 10px'
      }
    : {
        alignSelf: 'flex-end',
        backgroundColor: '#201D1D',
        borderRadius: '10px 0px 10px 10px',
        color: '#FFF'
      })
}));

export const MessageTimestamp = styled('div')({
  fontSize: '12px',
  color: '#888',
  display: 'block',
  position: 'absolute',
  bottom: '-19px',
  right: '0px'
});

export const MilaDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    width: '620px',
    backgroundColor: '#fff'
  }
});

export const PatientInfoText = styled('div')({
  marginTop: '8px',
  fontWeight: 500,
  fontSize: '16px',
  color: '#000000'
});

export const StyledTabs = styled(MuiTabs)({
  marginTop: '24px',
  borderBottom: '1px solid #D9D9D9',
  '& .MuiTab-root': {
    color: '#818181',
    fontWeight: 500,
    fontSize: '14px',
    '&.Mui-selected': {
      color: '#000000'
    }
  },
  '& .MuiTabs-indicator': {
    backgroundColor: '#0d6efd',
    height: 3
  }
});

export const SectionContainer = styled(Box)({
  display: 'flex',
  marginBottom: '16px'
});

export const SectionIndicator = styled(Box)({
  width: '4px',
  height: '22px',
  backgroundColor: '#0d6efd',
  borderRadius: '4px',
  marginRight: '12px',
  flexShrink: 0
});

export const StyledAccordion = styled(Accordion)({
  backgroundColor: 'transparent',
  '&:before': {
    display: 'none'
  }
});

export const StyledAccordionSummary = styled(AccordionSummary)({
  padding: 0,
  minHeight: 'auto',
  '& .MuiAccordionSummary-content': {
    margin: 0
  }
});

export const SectionTitle = styled(Typography)({
  color: '#000',
  fontWeight: 400,
  textTransform: 'uppercase'
});
